import { render, staticRenderFns } from "./CardBurstObsevationTable.vue?vue&type=template&id=c30aa76a&"
import script from "./CardBurstObsevationTable.vue?vue&type=script&lang=ts&"
export * from "./CardBurstObsevationTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports